import { DaoService } from "./DaoService";

export class ModeleService extends DaoService {

    static CLASS_NAME = "App\\Models\\Modele";
    
    static getInstance() {
        return super.getInstance('modele');
    }

    enable(idOrUid) {
        return ModeleService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid) {
        return ModeleService.post(`${this.prefix}/${idOrUid}/disable`);
    }

    all() {
        return ModeleService.get(`${this.prefix}/all`);
    }

    search(data) {
        return ModeleService.post(`${this.prefix}/search`, data);
    }

}